import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import ProductPageImpl from './ProductPageImpl';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function ProductPage() {
    const dispatch = useDispatch();
    const { ProductList} = useSelector((state)=>state.dmpslice)
    useEffect(() => {
        //dispatch(openDrawer(false));
    },[]);

    return (
        < ProductPageImpl />
    )

}